/**
 * Settings accessible on both client and server.
 *
 * DO NOT put sensitive info here, that should go in settings.js
 */
module.exports = {
  INSTALLED_TEMPLATES: [
    'Blank',
    'CenterText',
    'ErrorPage',
    'EventList',
    'Event',
    'FutureSightDetails',
    'FutureSightLanding',
    'FutureSightTag',
    'HeaderFlexContent',
    'HeroImage',
    'Homepage',
    'PressRoomLanding',
    'VideoPlayerPage'
  ],
  INSTALLED_WIDGETS: [
    'Accordion',
    'AddToCalendar',
    'AppSection',
    'AssetsDownload',
    'Banner',
    'Billboard',
    'BioOverlay',
    'BoldButton',
    'BreadCrumbs',
    'CancelFreeRide',
    'ColumnHighlight',
    'Columns',
    'ContactBlock',
    'CopyLanding',
    'CTABanner',
    'CTASection',
    'CTAWidget',
    'DescriptiveGallery',
    'DescriptiveImage',
    'DescriptiveIntro',
    'DoubleHead',
    'EventPreview',
    'FlexibleColumns',
    'FlexibleGallery',
    'Footer',
    'Footnote',
    'FormulaECalendar',
    'FullPageSideText',
    'FutureSightFeatures',
    'FutureSightImage',
    'FutureSightPostHeader',
    'FutureSightSeparator',
    'GalleryIndex',
    'GenericSeparator',
    'GoogleMap',
    'HeroLanding',
    'HomepageCarousel',
    'HomePageGallery',
    'HTML',
    'ImageGallery',
    'InTheNews',
    'Label',
    'LivestreamVideoPlayer',
    'LivestreamTcPlayer',
    'MapViewHeader',
    'MediaDownload',
    'MenuBar',
    'NonDescriptiveIntro',
    'OnionPeel',
    'QRColumns',
    'Questions',
    'RelatedArticles',
    'RichText',
    'ScrollGallery',
    'ScrollVideo',
    'SectionIntro',
    'SectionParagraph',
    'Showcase',
    'SimpleFooter',
    'StickyBar',
    'StickySubNav',
    'Subscribe',
    'SubscribeV2',
    'TinyMCE',
    'TitledItemList',
    'TitleText',
    'VerticalNavBar',
    'VideoImageCarousel',
    'VideoPlayer',
    'VideoTwoUps',
    'VRModule',
    'WaterfallGallery',
  ],
  REGIONS: [
    'CN',
    'US'
  ]
};
